import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin, Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProdutoService {
  private readonly baseUrl = `${environment.apiBaseUrl}/Product`;

  constructor(private http: HttpClient) {}

  buscarMenorPrecoSaude(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/CheapestActiveHealthProduct`).pipe(
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  buscarMenorPrecoOdonto(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/CheapestActiveDentalProduct`).pipe(
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  // [CORREÇÃO]: Realiza a busca paralela nos endpoints de Saúde e Odonto com normalização de dados
  buscarDadosDaApi(): Observable<{ List: any[] }> {
    return forkJoin({
      saude: this.buscarMenorPrecoSaude().pipe(catchError(() => of({ list: [] }))),
      odonto: this.buscarMenorPrecoOdonto().pipe(catchError(() => of({ list: [] }))),
    }).pipe(
      map(res => {
        const listaSaude = (res.saude?.list || []).map((item: any) => this.normalizarProduto(item, 'Saúde'));
        const listaOdonto = (res.odonto?.list || []).map((item: any) => this.normalizarProduto(item, 'Odonto'));

        return {
          List: [...listaSaude, ...listaOdonto],
        };
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  listarProdutos(): Observable<any> {
    return this.buscarDadosDaApi();
  }

  private normalizarProduto(item: any, tipoFallback: string): any {
    return {
      IdOperadora: item.operatorId || item.IdOperadora,
      NomeOperadora: item.operatorName || item.NomeOperadora,
      Ans: item.ans || item.Ans,
      TipoProduto: item.productType || item.TipoProduto || tipoFallback,
      NomeProduto: item.productName || item.NomeProduto,
      De: item.minAge ?? item.De ?? 0,
      Ate: item.maxAge ?? item.Ate ?? 0,
      Valor: item.value ?? item.Valor,
      Validade: item.validity || item.Validade || '',
    };
  }
}
